import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { ContactFormLinkFormatting } from "@faire/retailer-visitor-shared/components/Links";
import { buildPageLink } from "@faire/retailer-visitor-shared/lib/pathUtils";
import { useUserStore } from "@faire/retailer-visitor-shared/stores/domain/UserStore";
import { StickySaveProfileButton } from "@faire/retailer-visitor-shared/views/settings/components/StickySaveProfileButton";
import { EmailPreferencesContentWrapper } from "@faire/retailer-visitor-shared/views/settings/email-preferences/components/EmailPreferencesForm";
import { useBrandSentEmailPreferencesQuery } from "@faire/retailer-visitor-shared/views/settings/email-preferences/hooks/useBrandSentEmailPreferencesQuery";
import { useEmailPreferencesQuery } from "@faire/retailer-visitor-shared/views/settings/email-preferences/hooks/useEmailPreferencesQuery";
import { isNotUndefined } from "@faire/web--source/common/typescriptUtils";
import { Button } from "@faire/web--source/slate/Button";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { LoadingSpinner } from "@faire/web--source/slate/LoadingSpinner";
import { Pagination } from "@faire/web--source/slate/Pagination";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { Toggle } from "@faire/web--source/slate/Toggle";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { useMutation as useUpdateBrandPreferencesMutation } from "@faire/web-api--source/api/email/preferences/retailer-brand-preferences/post-hooks";
import { IBrandEmailSubscriptionStatus } from "@faire/web-api--source/com/faire/email/preferences/IBrandEmailSubscriptionStatus";
import { IUpdateRetailerBrandEmailPreferencesRequest } from "@faire/web-api--source/com/faire/email/preferences/IUpdateRetailerBrandEmailPreferencesRequest";
import { trackRetailerSettingsPageBrandSentEmailsBulkActionClick } from "@faire/web-api--source/events/retailerSettingsPage/click/brandSentEmailsBulkAction";
import { UnsubscribedMarketingType } from "@faire/web-api--source/indigofair/data/UnsubscribedMarketingType";
import React, { useCallback, useEffect, useState } from "react";
import styled from "styled-components";
export var BrandSentEmailPreferences = function(param) {
    var scrollToTopOfTable = param.scrollToTopOfTable;
    var _emailPreferencesResponse_unsubscribed_marketing_types, _brandSubscriptionPreferences_pagination_data;
    var emailAddress = useUserStore([
        "emailAddress"
    ]).emailAddress;
    var _useEmailPreferencesQuery = useEmailPreferencesQuery(), emailPreferencesResponse = _useEmailPreferencesQuery.emailPreferencesResponse, updateEmailPreferencesQuery = _useEmailPreferencesQuery.updateEmailPreferencesQuery;
    var _useState = _sliced_to_array(useState(IUpdateRetailerBrandEmailPreferencesRequest.BulkSubscribeStatus.NO_ACTION), 2), bulkSubscribeAction = _useState[0], setBulkSubscribeAction = _useState[1];
    var _useState1 = _sliced_to_array(useState(new Map()), 2), modifiedBrands = _useState1[0], setModifiedBrands = _useState1[1];
    var _useState2 = _sliced_to_array(useState(false), 2), hasJustUpdated = _useState2[0], setHasJustUpdated = _useState2[1];
    var _useBrandSentEmailPreferencesQuery = useBrandSentEmailPreferencesQuery(), brandSubscriptionPreferences = _useBrandSentEmailPreferencesQuery.brandSubscriptionPreferences, isLoading = _useBrandSentEmailPreferencesQuery.isLoading, isError = _useBrandSentEmailPreferencesQuery.isError, isFetched = _useBrandSentEmailPreferencesQuery.isFetched, removeBrandPreferencesQueriesForAllPages = _useBrandSentEmailPreferencesQuery.removeBrandPreferencesQueriesForAllPages;
    var handleSuccessfulUpdate = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(response) {
            return _ts_generator(this, function(_state) {
                // update email-preferences query to reflect whether retailer has bulk-actioned subscriptions for all brands
                updateEmailPreferencesQuery(function(emailPreferences) {
                    if (response.is_unsubscribed_from_all_brands === false) {
                        return _object_spread_props(_object_spread({}, emailPreferences), {
                            unsubscribed_marketing_types: emailPreferences.unsubscribed_marketing_types.filter(function(type) {
                                return type !== UnsubscribedMarketingType.BRAND_CRM_SENT;
                            })
                        });
                    } else if (response.is_unsubscribed_from_all_brands && !emailPreferences.unsubscribed_marketing_types.includes(UnsubscribedMarketingType.BRAND_CRM_SENT)) {
                        return _object_spread_props(_object_spread({}, emailPreferences), {
                            unsubscribed_marketing_types: _to_consumable_array(emailPreferences.unsubscribed_marketing_types).concat([
                                UnsubscribedMarketingType.BRAND_CRM_SENT
                            ])
                        });
                    }
                    return emailPreferences;
                });
                removeBrandPreferencesQueriesForAllPages();
                setHasJustUpdated(true);
                return [
                    2
                ];
            });
        });
        return function handleSuccessfulUpdate(response) {
            return _ref.apply(this, arguments);
        };
    }();
    var _useUpdateBrandPreferencesMutation = useUpdateBrandPreferencesMutation({
        onSuccess: handleSuccessfulUpdate
    }), updateBrandSubscriptionPreferences = _useUpdateBrandPreferencesMutation.mutateAsync, isUpdatePending = _useUpdateBrandPreferencesMutation.isPending;
    useEffect(function() {
        if (hasJustUpdated && isFetched) {
            // reset local changes
            setModifiedBrands(new Map());
            setBulkSubscribeAction(IUpdateRetailerBrandEmailPreferencesRequest.BulkSubscribeStatus.NO_ACTION);
            setHasJustUpdated(false);
        }
    }, [
        hasJustUpdated,
        isFetched
    ]);
    var toggleUnsubscribe = useCallback(function(brandToken, toggleValue) {
        setModifiedBrands(function(prevModifiedBrands) {
            var modifiedBrands = new Map(prevModifiedBrands);
            if (modifiedBrands.has(brandToken)) {
                // toggling a brand that has already been modified reverts to initialState, so remove from modifiedBrands
                modifiedBrands.delete(brandToken);
            } else {
                modifiedBrands.set(brandToken, !toggleValue);
            }
            return modifiedBrands;
        });
    }, []);
    var handleSave = useCallback(/*#__PURE__*/ _async_to_generator(function() {
        var brandEmailPreferences;
        return _ts_generator(this, function(_state) {
            brandEmailPreferences = Array.from(modifiedBrands, function(param) {
                var _param = _sliced_to_array(param, 2), brandToken = _param[0], isUnsubscribed = _param[1];
                return IBrandEmailSubscriptionStatus.build({
                    brand_token: brandToken,
                    unsubscribed: isUnsubscribed
                });
            });
            return [
                2,
                updateBrandSubscriptionPreferences([
                    IUpdateRetailerBrandEmailPreferencesRequest.build({
                        brand_email_preferences: brandEmailPreferences,
                        bulk_action: bulkSubscribeAction,
                        email_address: emailAddress
                    })
                ])
            ];
        });
    }), [
        modifiedBrands,
        updateBrandSubscriptionPreferences,
        emailAddress,
        bulkSubscribeAction
    ]);
    var handleBulkAction = useCallback(function(bulkAction) {
        trackRetailerSettingsPageBrandSentEmailsBulkActionClick(bulkAction === IUpdateRetailerBrandEmailPreferencesRequest.BulkSubscribeStatus.UNSUBSCRIBE_TO_ALL ? "opt-out" : "opt-in");
        // remove all brand-level edits to be overridden by bulk action status
        setModifiedBrands(new Map());
        setBulkSubscribeAction(bulkAction);
    }, [
        setModifiedBrands,
        setBulkSubscribeAction
    ]);
    var getCurrentBrandUnsubscribeStatus = useCallback(function(brandToken, initialUnsubscribeStatus) {
        // if any edits have been made, show them from most specific (brand-level) to least specific (bulk action)
        var editedStatus = modifiedBrands.get(brandToken);
        if (isNotUndefined(editedStatus)) {
            return editedStatus;
        }
        if (bulkSubscribeAction === IUpdateRetailerBrandEmailPreferencesRequest.BulkSubscribeStatus.RESUBSCRIBE_TO_ALL) {
            return false;
        }
        if (bulkSubscribeAction === IUpdateRetailerBrandEmailPreferencesRequest.BulkSubscribeStatus.UNSUBSCRIBE_TO_ALL) {
            return true;
        }
        // default to initial unsubscribe status before any changes were made
        return initialUnsubscribeStatus;
    }, [
        modifiedBrands,
        bulkSubscribeAction
    ]);
    var isCurrentlyUnsubscribedFromAllBrands = emailPreferencesResponse === null || emailPreferencesResponse === void 0 ? void 0 : (_emailPreferencesResponse_unsubscribed_marketing_types = emailPreferencesResponse.unsubscribed_marketing_types) === null || _emailPreferencesResponse_unsubscribed_marketing_types === void 0 ? void 0 : _emailPreferencesResponse_unsubscribed_marketing_types.includes(UnsubscribedMarketingType.BRAND_CRM_SENT);
    if (bulkSubscribeAction === IUpdateRetailerBrandEmailPreferencesRequest.BulkSubscribeStatus.RESUBSCRIBE_TO_ALL) {
        isCurrentlyUnsubscribedFromAllBrands = false;
    } else if (bulkSubscribeAction === IUpdateRetailerBrandEmailPreferencesRequest.BulkSubscribeStatus.UNSUBSCRIBE_TO_ALL) {
        isCurrentlyUnsubscribedFromAllBrands = true;
    }
    var isEdited = bulkSubscribeAction !== IUpdateRetailerBrandEmailPreferencesRequest.BulkSubscribeStatus.NO_ACTION || modifiedBrands.size > 0;
    if (isLoading) {
        return /*#__PURE__*/ _jsxs(Column, {
            align: "center",
            children: [
                /*#__PURE__*/ _jsx(LoadingSpinner, {}),
                /*#__PURE__*/ _jsx(Spacer, {
                    height: "5x"
                })
            ]
        });
    }
    if (isError) {
        return /*#__PURE__*/ _jsxs(Column, {
            children: [
                /*#__PURE__*/ _jsx(Typography, {
                    color: Core.text.critical,
                    children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "1u0FcY",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Something went wrong. Please try again or "
                            },
                            {
                                type: 8,
                                value: "ContactFormLinkFormatting",
                                children: [
                                    {
                                        type: 0,
                                        value: "contact us"
                                    }
                                ]
                            },
                            {
                                type: 0,
                                value: "."
                            }
                        ],
                        values: {
                            ContactFormLinkFormatting: ContactFormLinkFormatting
                        }
                    })
                }),
                /*#__PURE__*/ _jsx(Spacer, {
                    height: "5x"
                })
            ]
        });
    }
    if (!(brandSubscriptionPreferences === null || brandSubscriptionPreferences === void 0 ? void 0 : brandSubscriptionPreferences.brands.length)) {
        return /*#__PURE__*/ _jsxs(Column, {
            children: [
                /*#__PURE__*/ _jsx(Typography, {
                    color: Core.text.subdued,
                    children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "f3uJwg",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Brands that email you will be listed here."
                            }
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx(Spacer, {
                    height: "5x"
                })
            ]
        });
    }
    var _brandSubscriptionPreferences_pagination_data_total_results;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(EmailPreferencesContentWrapper, {
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "paragraphSansMedium",
                        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                            id: "q19+lL",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "All brands ("
                                },
                                {
                                    type: 1,
                                    value: "totalBrandsNumber"
                                },
                                {
                                    type: 0,
                                    value: ")"
                                }
                            ],
                            values: {
                                totalBrandsNumber: (_brandSubscriptionPreferences_pagination_data_total_results = brandSubscriptionPreferences === null || brandSubscriptionPreferences === void 0 ? void 0 : (_brandSubscriptionPreferences_pagination_data = brandSubscriptionPreferences.pagination_data) === null || _brandSubscriptionPreferences_pagination_data === void 0 ? void 0 : _brandSubscriptionPreferences_pagination_data.total_results) !== null && _brandSubscriptionPreferences_pagination_data_total_results !== void 0 ? _brandSubscriptionPreferences_pagination_data_total_results : "-"
                            }
                        })
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: 12
                    }),
                    /*#__PURE__*/ _jsxs(EmailPreferencesContainer, {
                        children: [
                            /*#__PURE__*/ _jsx(BrandSubscriptionStatusTableContainer, {
                                children: brandSubscriptionPreferences === null || brandSubscriptionPreferences === void 0 ? void 0 : brandSubscriptionPreferences.brands.map(function(brand) {
                                    return brand.brand_token ? /*#__PURE__*/ _jsx(BrandSubscriptionStatusRow, {
                                        brand: brand,
                                        isUnsubscribed: getCurrentBrandUnsubscribeStatus(brand.brand_token, !!brand.unsubscribed),
                                        onToggle: function(toggleValue) {
                                            return toggleUnsubscribe(brand.brand_token, toggleValue);
                                        },
                                        disabled: isUpdatePending
                                    }, brand.brand_token) : null;
                                })
                            }),
                            (brandSubscriptionPreferences === null || brandSubscriptionPreferences === void 0 ? void 0 : brandSubscriptionPreferences.pagination_data) ? /*#__PURE__*/ _jsx(StyledPagination, {
                                paginationData: brandSubscriptionPreferences.pagination_data,
                                pageToLink: buildPageLink,
                                disableButton: isUpdatePending,
                                onChangePage: scrollToTopOfTable
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: "4x"
                    }),
                    isCurrentlyUnsubscribedFromAllBrands ? /*#__PURE__*/ _jsx(Button, {
                        variant: "tertiary",
                        onClick: function() {
                            return handleBulkAction(IUpdateRetailerBrandEmailPreferencesRequest.BulkSubscribeStatus.RESUBSCRIBE_TO_ALL);
                        },
                        disabled: isUpdatePending,
                        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                            id: "efdqC7",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Opt in to all emails from brands via Faire"
                                }
                            ]
                        })
                    }) : /*#__PURE__*/ _jsx(Button, {
                        variant: "tertiary",
                        onClick: function() {
                            return handleBulkAction(IUpdateRetailerBrandEmailPreferencesRequest.BulkSubscribeStatus.UNSUBSCRIBE_TO_ALL);
                        },
                        disabled: isUpdatePending,
                        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                            id: "lSlO4p",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Opt out of all emails from brands via Faire"
                                }
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(StickySaveProfileButton, {
                isVisible: isEdited,
                onClickPromise: handleSave,
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "7i62MF",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Save"
                        }
                    ]
                })
            })
        ]
    });
};
var BrandSubscriptionStatusRow = function(param) {
    var brand = param.brand, isUnsubscribed = param.isUnsubscribed, onToggle = param.onToggle, disabled = param.disabled;
    return /*#__PURE__*/ _jsxs(StyledRow, {
        justify: "space-between",
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraphSansMedium",
                children: brand.brand_name
            }),
            /*#__PURE__*/ _jsx(Toggle, {
                value: !isUnsubscribed,
                onChange: onToggle,
                "data-test-id": "subscription-status-".concat(brand.brand_token),
                disabled: disabled,
                hideText: true
            })
        ]
    });
};
var EmailPreferencesContainer = styled(Column).withConfig({
    componentId: "sc-5476c109-0"
})([
    "max-width:670px;"
]);
var BrandSubscriptionStatusTableContainer = styled(Column).withConfig({
    componentId: "sc-5476c109-1"
})([
    "border:1px solid ",
    ";"
], Core.border.muted);
var StyledRow = styled(Row).withConfig({
    componentId: "sc-5476c109-2"
})([
    "padding:",
    ";margin:",
    ";border-top:1px solid ",
    ";&:first-of-type{border-top:unset;}"
], getSpacing("2x", 0), getSpacing(0, "3x"), Core.border.muted);
var StyledPagination = styled(Pagination).withConfig({
    componentId: "sc-5476c109-3"
})([
    "margin-top:",
    ";margin-bottom:",
    ";"
], getSpacing("4x"), getSpacing("2x"));
